import { parseDate, roundToXDecimals } from '@ais-ui/utils';
import { QueryPointResult } from './extractTargetInfo';

export interface AtonTargetInfo {
  assignedMode: string;
  atonType: string;
  country: string;
  flag: string;
  lastAisReport: Date | null;
  lastAisLatitude: string;
  lastAisLongitude: string;
  lastAisSatLatitude: string;
  lastAisSatLongitude: string;
  lastAisSatReport: Date | null;
  latitudeDegrees: string;
  longitudeDegrees: string;
  latitude: number;
  longitude: number;
  length: string;
  mmsi: string;
  name: string;
  offPosition: string;
  state: string;
  status: string;
  targetType: string;
  width: string;
  analogInternal: string;
  analogExternal1: string;
  analogExternal2: string;
  statusInternal: string;
  statusExternal: string;
}

const desiredTargetIds: string[] = [
  'assigned_mode',
  'country',
  'flag',
  'lastaisreport',
  'lastaissatreport',
  'length',
  'mmsi',
  'name',
  'off_position',
  'state',
  'status',
  'type',
  'width',
  'analog_int',
  'analog_ext1',
  'analog_ext2',
  'status_int',
  'status_ext',
];

const desiredTargetNames: string[] = [
  'Last AIS Latitude',
  'Last AIS Longitude',
  'Last AIS-Sat Latitude',
  'Last AIS-Sat Longitude',
  'Latitude',
  'Longitude',
];

export function extractAtonTargetInfos(
  result: QueryPointResult
): AtonTargetInfo[] {
  const atonTargetInfos: AtonTargetInfo[] = [];
  for (const target of result.targetInfo) {
    const rawAtonTargetInfo: { [key: string]: string } = {};
    for (const target_value of target.values) {
      // Here we map values by their ID
      if (desiredTargetIds.includes(target_value.id)) {
        rawAtonTargetInfo[target_value.id] = target_value.value;
      }
      // Some values have the same ID so here we map those by the NAME instead
      if (desiredTargetNames.includes(target_value.name)) {
        rawAtonTargetInfo[target_value.name] = target_value.value;
      }
    }
    const mmsi = target['mmsi'] || rawAtonTargetInfo['MMSI'];

    const AtonInfo: AtonTargetInfo = {
      assignedMode: rawAtonTargetInfo['assigned_mode'],
      atonType: rawAtonTargetInfo['type'],
      country: rawAtonTargetInfo['country'],
      flag: rawAtonTargetInfo['flag'],
      lastAisReport: parseDate(rawAtonTargetInfo['lastaisreport']),
      lastAisLatitude: rawAtonTargetInfo['Last AIS Latitude'],
      lastAisLongitude: rawAtonTargetInfo['Last AIS Longitude'],
      lastAisSatLatitude: rawAtonTargetInfo['Last AIS-Sat Latitude'],
      lastAisSatLongitude: rawAtonTargetInfo['Last AIS-Sat Longitude'],
      lastAisSatReport: parseDate(rawAtonTargetInfo['lastaissatreport']),
      latitudeDegrees: rawAtonTargetInfo['Latitude'],
      longitudeDegrees: rawAtonTargetInfo['Longitude'],
      latitude: target['lat']
        ? roundToXDecimals(target['lat'], 4)
        : target['lat'],
      longitude: target['lon']
        ? roundToXDecimals(target['lon'], 4)
        : target['lon'],
      length: rawAtonTargetInfo['length'],
      mmsi: mmsi,
      name: rawAtonTargetInfo['name'],
      offPosition: rawAtonTargetInfo['off_position'],
      state: rawAtonTargetInfo['state'],
      status: rawAtonTargetInfo['status'],
      targetType: target['type'],
      width: rawAtonTargetInfo['width'],
      analogInternal: rawAtonTargetInfo['analog_int'],
      analogExternal1: rawAtonTargetInfo['analog_ext1'],
      analogExternal2: rawAtonTargetInfo['analog_ext2'],
      statusInternal: rawAtonTargetInfo['status_int'],
      statusExternal: rawAtonTargetInfo['status_ext'],
    };
    atonTargetInfos.push(AtonInfo);
  }

  return atonTargetInfos;
}
